"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var consts_1 = require("../../consts");

var NamedObservable_1 = require("../NamedObservable");

var types_1 = require("./types");
/**
 * Sets or removes data from local storage in one of the specified data format.
 * If data is set to null, then it is removed from local storage.
 * If needed, it stringify data for persistance in local storage or parse such data to be retrieved in desired format.
 */


var LocalStorageHandlerProxy = /*#__PURE__*/function (_NamedObservable_1$Na) {
  _inherits(LocalStorageHandlerProxy, _NamedObservable_1$Na);

  var _super = _createSuper(LocalStorageHandlerProxy);

  function LocalStorageHandlerProxy() {
    _classCallCheck(this, LocalStorageHandlerProxy);

    return _super.apply(this, arguments);
  }

  _createClass(LocalStorageHandlerProxy, [{
    key: "saveItem",
    value:
    /**
     * Save string item to local storage.
     * @param name Unique key by which item is identified.
     * @param item String to be saved. If null, then item is completely removed from local storage.
     */
    function saveItem(name, item) {
      if (!consts_1.LOCAL_STORAGE_EXISTS) {
        return;
      }

      if (item) {
        window.localStorage.setItem(name, item);
      } else {
        window.localStorage.removeItem(name);
      }

      this.notifyChange(name, item);
    }
    /**
     * Retrieve string item from local storage.
     * @param name Unique key by which item is identified.
     */

  }, {
    key: "saveObject",
    value:
    /**
     * Stringify object and saves it to local storage.
     * @param name Unique key by which object is identified.
     * @param item Object to be saved. If null, then object is completely removed from local storage.
     */
    function saveObject(name, object) {
      if (!consts_1.LOCAL_STORAGE_EXISTS) {
        return;
      }

      if (object) {
        window.localStorage.setItem(name, JSON.stringify(object));
      } else {
        window.localStorage.removeItem(name);
      }

      this.notifyChange(name, object);
    }
    /**
     * Retrieve item from local storage and parse it as object.
     * @param name Unique key by which object is identified.
     */

  }, {
    key: "clearStorage",
    value: function clearStorage() {
      if (!consts_1.LOCAL_STORAGE_EXISTS) {
        return;
      }

      window.localStorage.clear();
      this.notifyChange(types_1.LocalStorageEvents.CLEAR, undefined);
    }
  }], [{
    key: "retrieveItem",
    value: function retrieveItem(name) {
      if (!consts_1.LOCAL_STORAGE_EXISTS) {
        return null;
      }

      return window.localStorage.getItem(name);
    }
  }, {
    key: "retrieveObject",
    value: function retrieveObject(name) {
      if (!consts_1.LOCAL_STORAGE_EXISTS) {
        return null;
      }

      var item = window.localStorage.getItem(name);

      if (item) {
        return JSON.parse(item);
      }

      return null;
    }
  }]);

  return LocalStorageHandlerProxy;
}(NamedObservable_1.NamedObservable);

exports.default = LocalStorageHandlerProxy;